import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { NotificationManager, SiteConfigManager } from '@atlas/core';
import { Toast } from '@atlas/ui';

import { useNotificationsUIContext } from 'common/Popup/NotificationsUIContext';

const NotificationPopup = props => {
  const { data, id, message, status } = props;
  const newNav = SiteConfigManager.getConfig('config.config.general.newMobileNavigation');
  const showNavForIframe = SiteConfigManager.getConfig(
    'config.config.sportsbook.showBottomNavigationMobile',
  );
  const { isBetslipOpen, isFlyingBetslip, isIframe, isPopupOpen, isQuickBet } =
    useNotificationsUIContext();

  const onCloseHandler = React.useCallback(() => NotificationManager.removeNotification(id), [id]);

  const toastClassName = cx('toast-mobile', {
    'is-iframe': isIframe,
    'new-nav': (isIframe && showNavForIframe) || (!isIframe && newNav),
    'with-flying-betslip': isFlyingBetslip,
    'with-open-popup': isPopupOpen || isBetslipOpen,
    'with-quick-bet': isQuickBet,
  });

  return (
    <Toast
      className={toastClassName}
      message={message}
      onClose={onCloseHandler}
      params={data}
      rawText={data?.rawText}
      type={status}
    />
  );
};

NotificationPopup.propTypes = {
  data: PropTypes.object,
};

export default NotificationPopup;
